export const mapRepcodes = (repCodes) => {
    return (repCodes || []).join(", ");
};